export default __webpack_public_path__ + "static/media/qr-code-2.1e2a33cd.svg";